export default __webpack_public_path__ + "static/media/logo-text.39cc07b2.png";